var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z",
    fill: "#FF5364"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5594 11.9999L15.8594 9.69986C16.1494 9.40986 16.1494 8.92986 15.8594 8.63986C15.5694 8.34986 15.0894 8.34986 14.7994 8.63986L12.4994 10.9399L10.1994 8.63986C9.90937 8.34986 9.42937 8.34986 9.13938 8.63986C8.84938 8.92986 8.84938 9.40986 9.13938 9.69986L11.4394 11.9999L9.13938 14.2999C8.84938 14.5899 8.84938 15.0699 9.13938 15.3599C9.28938 15.5099 9.47937 15.5799 9.66937 15.5799C9.85937 15.5799 10.0494 15.5099 10.1994 15.3599L12.4994 13.0599L14.7994 15.3599C14.9494 15.5099 15.1394 15.5799 15.3294 15.5799C15.5194 15.5799 15.7094 15.5099 15.8594 15.3599C16.1494 15.0699 16.1494 14.5899 15.8594 14.2999L13.5594 11.9999Z",
    fill: "#FF5364"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.a04bb7678156ece1c576e69beb08e043.svg";
export { ForwardRef as ReactComponent };